import { SxProps, Theme, styled } from "@mui/material";

const SpeechBubbleContainer = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: 4,
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[1],
  cursor: "default",
}));

const SpeechBubbleArrowContainer = styled("div")(({ theme }) => ({
  position: "absolute",
  bottom: "50%",
  left: -8,
  translate: "0% 65%",
  overflow: "hidden",
  width: 8,
  height: 16,
}));

const SpeechBubbleArrow = styled("div")(({ theme }) => ({
  height: "50%",
  width: "100%",
  translate: "50% 50%",
  backgroundColor: theme.palette.common.white,
  transform: "rotate(45deg)",
  borderLeft: `1px solid ${theme.palette.divider}`,
  boxShadow: theme.shadows[1],
}));

const SpeechBubble = (props: {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}) => {
  return (
    <SpeechBubbleContainer sx={props.sx}>
      {props.children}
      <SpeechBubbleArrowContainer>
        <SpeechBubbleArrow />
      </SpeechBubbleArrowContainer>
    </SpeechBubbleContainer>
  );
};

export default SpeechBubble;
